

































































































































































































































































































































































































































































































import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue';
import { db } from '@/db/importacoes';
import { GrupoEconomico } from '@/models/GrupoEconomico';
import { ColunaEsperada } from '@/models/ImportacaoDeCSV';
import { ClienteService } from '@/services';
import { uploadFilesToS3 } from '@/shareds/s3/files';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import AppStore from '@/store/vuex/aplicacao/AppStore';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import { FindGrupoEconomicoUseCase, FindImportacaoUseCase, SaveProdutoUseCase } from '@/usecases';
import { Vue, Component, Watch } from 'vue-property-decorator';

@Component({
	components: {
		SeletorDeLojasDoUsuario,
	},
})
export default class TelaDeImportacaoDeCSV extends Vue {
	findImportacaoUseCase = new FindImportacaoUseCase()
	findGrupoEconomicoUseCase = new FindGrupoEconomicoUseCase()
	clienteService = new ClienteService()
	saveProdutoUseCase = new SaveProdutoUseCase()

	valid = false;
	loading = false;
	tipoSelecionado = null;
	file: File | null = null;
	snackbar = false;
	snackbarText = '';
	snackbarColor = 'success';
	mostrarMapeamento = false;
	colunasDoArquivo: string[] = [];
	mapeamento: Record<string, string> = {};
	totalColunasFaltantes = 0;
	totalColunasDiferentes = 0;
	totalColunasCorretas = 0;
	arquivosPreMontados: File[] = [];
	gruposEconomicos: GrupoEconomico[] = [];
	grupoEconomicoId: string | null = null;
	lojas: string[] = [];
	loadingProcessoDeImportacao: Record<string, boolean> = {};
	visualizarDadosDoArquivo = false
	dadosDoArquivoVisualizacao: string[][] = []
	
	tiposDeProcesso = [
		{ 
			text: 'Importação de Clientes', 
			value: 'clientes',
			icon: 'mdi-account-multiple',
			description: 'Importar dados de clientes',
		},
		{ 
			text: 'Importação de Produtos', 
			value: 'produtos',
			icon: 'mdi-package-variant',
			description: 'Importar catálogo de produtos',
		},
	];

	colunaDeClientes: ColunaEsperada[] = [
		{ campo: 'nome', descricao: 'Nome completo', obrigatorio: true },
		{ campo: 'cnpj_cpf', descricao: 'CPF ou CNPJ', obrigatorio: true },
		{ campo: 'data_nascimento', descricao: 'Data de nascimento', obrigatorio: true },
		{ campo: 'email', descricao: 'E-mail', obrigatorio: true },
		{ campo: 'rua', descricao: 'Endereço (rua)', obrigatorio: true },
		{ campo: 'numero', descricao: 'Número', obrigatorio: true },
		{ campo: 'cep', descricao: 'CEP', obrigatorio: true },
		{ campo: 'bairro', descricao: 'Bairro', obrigatorio: true },
		{ campo: 'complemento', descricao: 'Complemento', obrigatorio: true },
		{ campo: 'cidade', descricao: 'Cidade', obrigatorio: true },
		{ campo: 'uf', descricao: 'Estado (UF)', obrigatorio: true },
		{ campo: 'incricao_estadual', descricao: 'Inscrição estadual', obrigatorio: true },
		{ campo: 'telefone', descricao: 'Telefone', obrigatorio: true },
		{ campo: 'tipo_cliente', descricao: 'Tipo de cliente', obrigatorio: true },
		{ campo: 'cod_ibge', descricao: 'Código IBGE', obrigatorio: true },
		{ campo: 'genero', descricao: 'Gênero', obrigatorio: true },
		{ campo: 'profissao_codigo', descricao: 'Código da profissão', obrigatorio: true },
		{ campo: 'notificacaoPorEmail', descricao: 'Notificação por e-mail', obrigatorio: true },
		{ campo: 'notificacaoPorWhatsapp', descricao: 'Notificação por WhatsApp', obrigatorio: true },
	];

	colunaDeProdutos: ColunaEsperada[] = [
		{ campo: 'referencia', descricao: 'Referência do produto', obrigatorio: true },
		{ campo: 'sku', descricao: 'SKU do produto', obrigatorio: true },
		{ campo: 'eans', descricao: 'EANs do Produto', obrigatorio: true },
		{ campo: 'nome', descricao: 'Nome do produto', obrigatorio: true },
		{ campo: 'descricao', descricao: 'Descrição do produto', obrigatorio: true },
		{ campo: 'ncm', descricao: 'NCM do produto', obrigatorio: true },
		{ campo: 'tags', descricao: 'Tags do produto', obrigatorio: true },
		{ campo: 'tipo', descricao: 'Tipo do produto', obrigatorio: true },
		{ campo: 'marca', descricao: 'Marca do produto', obrigatorio: true },
		{ campo: 'preco', descricao: 'Preço do produto', obrigatorio: true },
		{ campo: 'genero', descricao: 'Gênero do produto', obrigatorio: true },
		{ campo: 'categoria', descricao: 'Categoria do produto', obrigatorio: true },
		{ campo: 'urls_imagens', descricao: 'URL da imagem do produto', obrigatorio: true },
		{ campo: 'unidade_medida', descricao: 'Und. de Medida do produto', obrigatorio: true },
		{ campo: 'tamanho', descricao: 'Tamanho do produto', obrigatorio: true },
		{ campo: 'cor', descricao: 'Cor do produto', obrigatorio: true },
	];

	async abrirVisualizacaoDeArquivo() {
		if (!this.file) {
			AlertModule.setError('Nenhum arquivo selecionado para visualização.');
			return;
		}

		try {
			const texto = await this.file.text();
			const linhas = texto.split('\n').filter(linha => linha.trim().length > 0);

			if (linhas.length > 1) {
				this.dadosDoArquivoVisualizacao = linhas.slice(1).map(linha => {
					return linha.split(';').map(col => col.trim());
				});

				this.visualizarDadosDoArquivo = true;
			} else {
				AlertModule.setWarning('O arquivo selecionado não contém linhas de dados.');
			}

		} catch (error) {
			AlertModule.setError('Erro ao ler o conteúdo do arquivo para visualização.');
		}
	}

	getValorMapeado(linhaDados: string[], campoEsperado: string): string {
		const nomeColunaDoArquivo = this.mapeamento[campoEsperado];

		if (!nomeColunaDoArquivo) {
			return '- N/A -';
		}

		const indiceColunaNoArquivo = this.colunasDoArquivo.findIndex(
			col => col === nomeColunaDoArquivo,
		);

		if (indiceColunaNoArquivo !== -1) {
			return linhaDados[indiceColunaNoArquivo];
		}

		return '- N/A -';
	}

	esconderVisualizacaoDeArquivo(){
		this.visualizarDadosDoArquivo = false
	}

	get colunasEsperadas(){
		if(this.tipoSelecionado === 'clientes'){
			return this.colunaDeClientes;
		}
		if(this.tipoSelecionado === 'produtos'){
			return this.colunaDeProdutos;
		}else {
			return [];
		}
	}

	importacaoPreMontadas: any[] = [];

	async created() {
		this.gruposEconomicos = await this.findGrupoEconomicoUseCase.find();
		await this.carregarImportacoesPreMontadas();
	}

	async carregarImportacoesPreMontadas() {
		const itens = await db.importacoes.toArray();

		this.importacaoPreMontadas = itens
			.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
			.map(item => ({
				id: item.id,
				fileName: item.fileName,
				date: new Date(item.createdAt).toLocaleString('pt-BR'),
				status: 'success',
				records: item.records,
				mapeamento: item.mapeamento,
				tipo: item.tipo,
				lojas: item.lojas,
				grupoEconomicoId: item.grupoEconomicoId,
			}));
	}

	get colunasNaoMapeadas() {
		const mapeadas = Object.values(this.mapeamento).filter(v => v);
		return this.colunasDoArquivo.filter(col => !mapeadas.includes(col));
	}

	get mapeamentoValido() {
		if (!this.mostrarMapeamento) return true;
		return this.totalColunasFaltantes === 0;
	}

	async onFileChange(file: File | null) {
		if (file) {
			await this.processarArquivo(file);
		} else {
			this.mostrarMapeamento = false;
			this.colunasDoArquivo = [];
			this.mapeamento = {};
		}
	}

	async processarArquivo(file: File) {
		const texto = await file.text();
		const linhas = texto.split('\n');
		this.file = file;

		if(this.importacaoPreMontadas.some(imp => imp.fileName === file.name)){
			AlertModule.setError('Já existe uma importação pré-montada com esse nome de arquivo!');
			this.file = null;
			return;
		}
		
		if (linhas.length > 0) {
			const primeiraLinha = linhas[0];
			this.colunasDoArquivo = primeiraLinha
				.split(';')
				.map(col => col.trim())
				.filter(col => col.length > 0);
			
			this.criarMapeamentoAutomatico();
			this.mostrarMapeamento = true;
			if(this.file){
				this.arquivosPreMontados.push(this.file);
			}
		}
	}

	criarMapeamentoAutomatico() {
		this.mapeamento = {};
		
		this.colunasEsperadas.forEach(esperada => {
			const colunaExata = this.colunasDoArquivo.find(
				col => col.toLowerCase() === esperada.campo.toLowerCase(),
			);
			
			if (colunaExata) {
				this.mapeamento[esperada.campo] = colunaExata;
			} else {
				const colunaSimilar = this.colunasDoArquivo.find(col =>
					col.toLowerCase().includes(esperada.campo.toLowerCase()) ||
					esperada.campo.toLowerCase().includes(col.toLowerCase()),
				);
				
				if (colunaSimilar) {
					this.mapeamento[esperada.campo] = colunaSimilar;
				}
			}
		});
	}

	getOpcoesColuna() {
		return ['', ...this.colunasDoArquivo];
	}

	getStatusColuna(campo: string) {
		const mapeado = this.mapeamento[campo];
		
		if (!mapeado) {
			const obrigatorio = this.colunasEsperadas.find(c => c.campo === campo)?.obrigatorio;
			return {
				icon: obrigatorio ? 'mdi-alert-circle' : 'mdi-minus-circle',
				color: obrigatorio ? 'error' : 'grey',
			};
		}
		
		if (mapeado.toLowerCase() === campo.toLowerCase()) {
			return { icon: 'mdi-check-circle', color: 'success' };
		}
		
		return { icon: 'mdi-alert', color: 'warning' };
	}

	calculaTamanhoDoArquivo(bytes: number): string {
		if (bytes === 0) return '0 Bytes';
		const k = 1024;
		const sizes = ['Bytes', 'KB', 'MB', 'GB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
	}

	@Watch('mapeamento', { deep: true })
	contabilizaTagsDeAlerta(){
		this.totalColunasFaltantes = this.colunasEsperadas.length - Object.values(this.mapeamento).length;

		this.totalColunasDiferentes = Object.keys(this.mapeamento).filter(campo => {
			const valorMapeado = this.mapeamento[campo];
			return valorMapeado && valorMapeado.toLowerCase() !== campo.toLowerCase();
		}).length;

		this.totalColunasCorretas = this.colunasDoArquivo.filter(col => 
			this.colunasEsperadas.some(esp => esp.campo.toLowerCase() === col.toLowerCase()),
		).length;

	}

	async montarImportacao() {
		if (!(this.$refs.form as any).validate()) return;

		if (!this.mapeamentoValido || !this.file) {
			this.snackbarText = 'Preencha todos os campos e selecione o arquivo!';
			this.snackbarColor = 'error';
			this.snackbar = true;
			return;
		}

		if (this.tipoSelecionado === 'clientes' && this.lojas.length === 0) {
			AlertModule.setError('Selecione ao menos uma loja para importação de clientes');
			return;
		}

		this.loading = true;

		try {
			const texto = await this.file.text();
			const linhas = texto.split('\n').filter(l => l.trim().length > 0);
			const quantidadeRegistros = linhas.length > 1 ? linhas.length - 1 : 0;

			const id = gerarId();

			await db.importacoes.add({
				id,
				fileName: this.file.name,
				tipo: this.tipoSelecionado as any,
				blob: this.file,
				mapeamento: { ...this.mapeamento },
				grupoEconomicoId: this.grupoEconomicoId,
				lojas: [...this.lojas],
				records: quantidadeRegistros,
				createdAt: new Date().toISOString(),
			});

			this.importacaoPreMontadas.unshift({
				id,
				fileName: this.file.name,
				date: new Date().toLocaleString('pt-BR'),
				status: 'success',
				records: quantidadeRegistros,
				mapeamento: { ...this.mapeamento },
				tipo: this.tipoSelecionado,
				lojas: this.lojas,
				grupoEconomicoId: this.grupoEconomicoId,
			});

			this.snackbarText = 'Importação pré-montada com sucesso!';
			this.snackbarColor = 'success';
			this.snackbar = true;

			this.limpar();
		} catch (e) {
			AlertModule.setError('Erro ao salvar pré-importação no navegador');
		} finally {
			this.loading = false;
		}
	}


	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	async deleteImportacao(item: any) {
		await db.importacoes.delete(item.id);
		this.importacaoPreMontadas = this.importacaoPreMontadas
			.filter(imp => imp.id !== item.id);

		this.snackbarText = `Importação de ${item.fileName} excluída com sucesso!`;
		this.snackbarColor = 'error';
		this.snackbar = true;
	}

	async executarImportacao(item: any) {
		if(!this.permiteAbrirDiversosProcessosDeImportacao){
			if(!this.usuario){
				AlertModule.setError('Não foi possivel encontrar informações do usuário logado');
				return
			}

			const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario);

			if(!possuiProcessoEmAberto){
				AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
				this.loadingProcessoDeImportacao = {
					...this.loadingProcessoDeImportacao,
					[item.fileName]: false,
				};
				return
			}
		}


		this.snackbarText = `Executando importação de ${item.fileName}...`;
		this.snackbarColor = 'info';
		this.snackbar = true;

		this.loadingProcessoDeImportacao = {
			...this.loadingProcessoDeImportacao,
			[item.fileName]: true,
		};

		try {
			const registro = await db.importacoes.get(item.id);
			if (!registro) {
				AlertModule.setError('Arquivo da importação não encontrado no navegador');
				return;
			}

			const arquivoParaMontarImportacao = new File(
				[registro.blob],
				registro.fileName,
				{ type: 'text/csv' },
			);

			const texto = await arquivoParaMontarImportacao.text();
			const linhas = texto.split('\n').filter(linha => linha.trim().length > 0);

			const novoCabecalho = this.colunasEsperadas
				.map(coluna => item.mapeamento[coluna.campo] || '')
				.filter(col => col)
				.join(';');

			const arquivoFinal = [novoCabecalho, ...linhas.slice(1)].join('\n');

			if (item.tipo === 'clientes') {
				const informacoesDosArquivos = await uploadFilesToS3(
					[new File([arquivoFinal], registro.fileName, { type: 'text/csv' })],
					`importacao-de-clientes`,
				);

				const urlDoArquivoCsv = informacoesDosArquivos.map(({ config }) => config.url)[0];

				if (!urlDoArquivoCsv) {
					this.loadingProcessoDeImportacao = {
						...this.loadingProcessoDeImportacao,
						[item.fileName]: false,
					};
					return AlertModule.setError("Ocorreu um erro interno, contate o suporte");
				}

				if(!registro.grupoEconomicoId){
					this.loadingProcessoDeImportacao = {
						...this.loadingProcessoDeImportacao,
						[item.fileName]: false,
					};
					AlertModule.setError('Grupo econômico é obrigatório para importação de clientes');
					return
				}

				await this.clienteService.importaItens(
					urlDoArquivoCsv,
					true,
					registro.grupoEconomicoId,
					registro.lojas,
				);

				AlertModule.setSuccess('Item em processamento');
			}

			if(item.tipo === 'produtos'){
				if(!this.usuario) return

				try {
					const informacoesDosArquivos = await uploadFilesToS3([new File([arquivoFinal], registro.fileName, { type: 'text/csv' })], 'produtos-csv')
					const urlDoArquivoCsv = informacoesDosArquivos.map(({ config }) => config.url)[0];

					if(urlDoArquivoCsv) {
						await this.saveProdutoUseCase.adicionarImportacao(urlDoArquivoCsv, true)
					}
				} catch (e) {
					AlertModule.setError(e)
				} finally {
					this.snackbarText = `Importação: ${item.fileName} em processamento`;
					this.snackbarColor = 'success';
					this.snackbar = true;
				}
			}

			await db.importacoes.delete(item.id);
			this.importacaoPreMontadas = this.importacaoPreMontadas.filter(imp => imp.id !== item.id);
		} catch (error: any) {
			AlertModule.setError('Erro ao processar importação: ' + error);
		} finally {
			this.loadingProcessoDeImportacao = {
				...this.loadingProcessoDeImportacao,
				[item.fileName]: false,
			};
		}
	}

	limpar() {
		this.tipoSelecionado = null;
		this.file = null;
		this.mostrarMapeamento = false;
		this.colunasDoArquivo = [];
		this.mapeamento = {};
		(this.$refs.form as any)?.resetValidation();
		this.grupoEconomicoId = null
		this.lojas = [];
	}

	get modoNoturno() {
		return AppStore.modoNoturno
	}

	async baixarModeloClientes() {
		const rows = [
			[
				'nome','cnpj_cpf','data_nascimento','email','rua','numero','cep','bairro','complemento','cidade','uf','incricao_estadual','telefone','tipo_cliente','cod_ibge', 'genero', 'profissao_codigo', 'notificacaoPorEmail', 'notificacaoPorWhatsapp',
			],
			[
				'Ian Edson','426.512.715-00','05/01/1983','ianedsondamota@transportadoratransdel.com.br','Rua Sergio Abrantes','490','58804-045','Frei Damiao','complemento','Sousa','PB','12345678-9','(83) 98703-4272','tipo_cliente','9999999', 'Masculino', '001', 'false', 'false',
			],
		]

		const csvContent = "data:text/csv;charset=utf-8," 
			+ rows.map(e => e.join(";")).join("\n")

		const encodedUri = encodeURI(csvContent)
		const link = document.createElement("a")
		link.setAttribute("href", encodedUri)
		link.setAttribute("download", "modelo_importacao_cliente.csv")
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	async baixarModeloProdutos() {
		const rows = [
			[
				'referencia','sku','eans','nome','descricao','ncm','tags','tipo','marca','preco','genero','categoria','urls_imagens','unidade_medida','tamanho','cor',
			],
			[
				'ABC123','ABC123GGBRANCO','123456789,987654321','Exemplo Produto Com Variantes 1','Uma descrição informativa','62046200','TAG1,TAG2','COM_VARIANTES','MARCA1','0.00','MASCULINO','CATEGORIA1','http://exemplo.com/imagens/exemplo_1.jpg','UN','GG','BRANCO',
			],
			[
				'ABC123','ABC123GGPRETO','678912345,432198765','Exemplo Produto Com Variantes 2','Uma descrição informativa','62046200','TAG1,TAG2','COM_VARIANTES','MARCA1','0.00','MASCULINO','CATEGORIA1','http://exemplo.com/imagens/exemplo_2.jpg','UN','GG','PRETO',
			],
			[
				'','789XYZ','789456123','Exemplo Produto Padrao','Uma descrição informativa','62046200','TAG1,TAG2','PADRAO','MARCA2','0.00','MASCULINO','CATEGORIA2','http://exemplo.com/imagens/exemplo_3.jpg','UN','','',
			],
		]

		const csvContent = "data:text/csv;charset=utf-8," 
			+ rows.map(e => e.join(";")).join("\n")

		const encodedUri = encodeURI(csvContent)
		const link = document.createElement("a")
		link.setAttribute("href", encodedUri)
		link.setAttribute("download", "modelo_importacao_produto.csv")
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}
}

function gerarId() {
	const c: any = (window as any).crypto || (window as any).msCrypto;
	if (c?.randomUUID) return c.randomUUID();
	return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

